<template>
  <div class="row" >
    <div class="col-12">
      <div class="d-flex pb-3">
        <b-button class="ms-auto me-3"
          variant="warning"
          @click="goBack"
        >
          {{$t('modal.button.back')}}
        </b-button>

        <b-button
          variant="success"
          @click="onPut"
          :disabled="db"
        >
          {{$t('modal.button.put')}}
        </b-button>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-4"
      v-for="(permissions, index) in permissionsData"
      :key="index"
    >
      <div class="permissionsCard">
        <h4 class="permissionsHeader">
          {{$t(`permissionsList.${permissions.name}`)}}
        </h4>
        <div class="permissionsParentContainer">
          <b-form-checkbox
            v-model="checkedPermissions"
            :value="permissions.name"
          ></b-form-checkbox>
          <p class="permissionsTitle">
            {{$t(`permissionsList.${permissions.name}`)}}
          </p>
        </div>
        <div class="permissionsChildrenContainer">
          <div class="permissionsChildrenCard"
            v-for="(child, index) in permissions.children"
            :key="index"
          >
            <b-form-checkbox
              v-model="checkedPermissions"
              :value="child.name"
            ></b-form-checkbox>
            <p class="permissionsSubtitle">
              {{$t(`permissionsList.${child.name}`)}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getRolesID, storePutRole} from '../../../api/endpoints/roles';
  import {getPermissions} from '../../../api/endpoints/permissions'
  export default {
    name: "PermissionRoles",
    data() {
      return {
        id: null,
        permissionsData: [],
        checkedPermissions: [],
        formData: {
          id: null,
          name: '',
          name_uz: "",
          name_ru: "",
          permissions: []
        },
        db: false,
      }
    },
    mounted() {
      this.getID();
      this.onGetRole();
      this.onGetPermissions();
    },
    methods: {
      getID() {
        this.id = this.$route.params.permissions
      },
      onGetRole() {
        getRolesID(this.id).then( res => {
          this.checkedPermissions = res.data.data.permissions.map(item => item.name);
          this.formData = res.data.data;
        })
      },
      onGetPermissions() {
        getPermissions({all: true}).then( res => {
          this.permissionsData = res.data.data
        })
      },
      goBack() {
        this.$router.push('/management/roles');
      },
      onPut() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        storePutRole({
          id: this.id,
          name: this.formData.name,
          name_uz: this.formData.name_uz,
          name_ru: this.formData.name_ru,
          permissions: this.checkedPermissions
        }).then( () => {
          this.goBack();
        })
      },
    },
  }
</script>

<style lang="scss">
  .custom-control-label {
    margin-left: 10px;
    text-transform: capitalize;
  }
  
  .permissionsCard {
    background-color: white;
    padding: 20px 10px;
    margin-bottom: 10px;
    min-height: 220px;

    .permissionsHeader {
      border-bottom: 1px solid gray;
      padding-bottom: 5px;
      
    }

    .permissionsParentContainer {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .permissionsTitle {
        margin-bottom: 0;
        font-size: 15px;
      }
    }

    .permissionsChildrenContainer {
      padding-left: 20px;

      .permissionsChildrenCard {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 7px;

        .permissionsSubtitle {
          margin-bottom: 0;
        }
      }
    }

    
  }
</style>